<template>
  <div
    class="header"
    :style="
      routePath === '/' || routePath === '/home'
        ? { height: '126px' }
        : { height: '161px' }
    "
  >
    <div class="header-icon">
      <router-link to="home">
        <img src="~@/assets/images/logo.png" />
      </router-link>
    </div>
    <div
      class="header-link-area"
      :style="
        routePath === '/' || routePath === '/home'
          ? { height: '35px' }
          : { height: '70px' }
      "
    >
      <div class="header-link">
        <router-link
          v-for="item in functionList"
          :key="item.id"
          :to="{ path: `/${item.id}`, query: { page: '1' } }"
          >{{ item.name }}</router-link
        >
      </div>
      <div v-for="functionListItem in functionList" :key="functionListItem.id">
        <div
          v-if="routePath === `/${functionListItem.id}`"
          class="header-sub-link"
        >
          <router-link
            v-for="subFunctionListItem in functionListItem.subList"
            :key="subFunctionListItem.subId"
            :to="{
              path: `/${functionListItem.id}`,
              query: { page: subFunctionListItem.subId },
            }"
            >{{ subFunctionListItem.subName }}</router-link
          >
        </div>
      </div>
    </div>
    <div class="env" v-if="envFlag !== 'prod'">測試環境</div>
  </div>
</template>

<script>
import store from 'Store/store';
import FunctionList from 'Assets/mockData/FunctionList.json';
export default {
  name: 'Header',
  data() {
    return {
      envFlag: process.env.VUE_APP_MODE,
      routePath: this.$route.path,
      functionList: FunctionList,
    };
  },
  methods: {
    checkShowing(item) {
      if (item.subName === '線上點燈') {
        return store.state.main.onlineStatus.lightInfo.enable;
      } else if (item.subName === '平安宴') {
        return store.state.main.onlineStatus.reposeInfo.enable;
      }
      return true;
    },
  },
  watch: {
    $route() {
      this.routePath = this.$route.path;
    },
  },
};
</script>
<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 161px;
  z-index: 4;
  background: #ffffff;
  display: flex;
  align-items: center;
}
.header-icon {
  width: 100%;
  height: 90px;
  position: absolute;
  top: 0;
  border-bottom: 1px solid #eab36f;
}
.header-link-area {
  display: block;
  width: 100%;
  height: 70px;
  position: absolute;
  bottom: 0;
}
.header-link {
  height: 35px;
  line-height: 35px;
  background-color: #ffffff;
  margin: auto;
}
.header-link > a {
  color: #8d7f6d;
  margin: 30px;
}
.header-sub-link {
  height: 35px;
  line-height: 35px;
  background-color: #000000;
  margin: auto;
}
.header-sub-link > a {
  color: #ffffff;
  margin: 25px;
}
.header-link > a:hover,
.header-sub-link > a:hover {
  color: #aaa;
  text-decoration: none;
}
.env {
  position: fixed;
  right: 5px;
  top: 0px;
  font-size: 20px;
  color: crimson;
}
.hide-item {
  display: none;
}
@media (max-width: 767px) {
  .header {
    height: 90px !important;
  }
  .header-link-area {
    display: none;
  }
}
</style>
